// extracted by mini-css-extract-plugin
export default {"messages":"Messages-messages-FTWzW"};